import { useEffect, useState } from "react";
import { getVatSummary } from "../../../../services/accounting";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import { getUrlQuerysection } from "../../../../helpers";
import { useSearchParams } from "react-router-dom";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";
import { useGetVatLogs } from "../../../../hooks/api/queries";

export const useVatLogs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const queries = getUrlQuerysection();
  const queryParams = new URLSearchParams(window.location.search);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { storeHasMultipleCurrency } = useStoreCurrency();
  const [selectedTableTab, setSelectedTableTab] = useState("vat_outflow");
  const [isVatLogsExport, setIsVatLogsExport] = useState(false);
  const [isChargeVatFilter, setIsChargeVatFilter] = useState(
    searchParams.get("is_charged") || "VAT Charged?",
  );
  const tableTab = [
    {
      label: "VAT Collected",
      key: "vat_outflow",
      showOnLocalSetup: false,
    },
    {
      label: "VAT on Purchases",
      key: "vat_inflow",
      showOnLocalSetup: false,
    },
  ];

  const [startDate, setStartData] = useState(searchParams.get("start_date"));
  const [endDate, setEndDate] = useState(searchParams.get("end_date"));
  const [currentStore, setCurrentStore] = useState(
    storeHasMultipleCurrency
      ? queryParams.get("store_id") || storeList[0]?.id
      : "",
  );

  useEffect(() => {
    if (storeList.length > 0 && storeHasMultipleCurrency) {
      searchParams.set("store_id", storeList[0]?.id);
      setSearchParams(searchParams, { replace: true });
    }
  }, [storeList, storeHasMultipleCurrency]);

  const vatSummaryQueryKey = {
    store_id: searchParams.get("store_id"),
    start_date: searchParams.get("start_date"),
    end_date: searchParams.get("end_date"),
  };

  const { data: vatSummary, isLoading: isFetchingVatSummary } = useQuery(
    ["vatSummary", vatSummaryQueryKey],
    () => getVatSummary(queries).then((res) => res?.data?.data),
    { staleTime: Infinity },
  );

  const setDateFilter = (data) => {
    const { startDate, endDate } = data;
    searchParams.set("start_date", startDate);
    searchParams.set("end_date", endDate);
    setStartData(startDate);
    setEndDate(endDate);
    setSearchParams(searchParams, { replace: true });
  };

  const filterByStoreId = (storeId) => {
    if (storeId === "ALL_STORES") searchParams.delete("store_id");
    else searchParams.set("store_id", storeId);
    setSearchParams(searchParams, { replace: true });
  };

  const filterIsVatCharged = (value) => {
    setIsChargeVatFilter(value);
    if (value === "" || value === undefined) searchParams.delete("is_charged");
    else searchParams.set("is_charged", value);
    setSearchParams(searchParams, { replace: true });
  };

  useEffect(() => {
    searchParams.set("page", 1);
    setSearchParams(searchParams, { replace: true });
  }, [selectedTableTab]);

  const gotoPage = (pageNumber) => {
    searchParams.set("page", pageNumber);
    setSearchParams(searchParams, { replace: true });
  };

  const { data: vatInflowData, isLoading: isLoadingVatInflowData } =
    useGetVatLogs({
      queries,
      queryParams: { transaction_type: "INFLOW" },
      isEnabled: selectedTableTab === "vat_inflow",
    });

  const { data: vatOutflowData, isLoading: isLoadingvatOutflowData } =
    useGetVatLogs({
      queries,
      queryParams: { transaction_type: "OUTFLOW" },
      isEnabled: selectedTableTab === "vat_outflow",
    });

  return {
    startDate,
    endDate,
    vatSummaryData: vatSummary,
    isFetchingData: isFetchingVatSummary,
    storeList,
    storeHasMultipleCurrency,
    currentStore,
    selectedTableTab,
    tableTab,
    vatInflowData: vatInflowData?.data || [],
    vatInflowMetaData: vatInflowData?.meta || {},
    isLoadingVatInflowData,
    vatOutflowData: vatOutflowData?.data || [],
    vatOutflowMetaData: vatOutflowData?.meta || {},
    isLoadingvatOutflowData,
    isVatLogsExport,
    isChargeVatFilter,
    setSelectedTableTab,
    setCurrentStore,
    setDateFilter,
    filterByStoreId,
    gotoPage,
    setIsVatLogsExport,
    filterIsVatCharged,
  };
};
